import "./modal.scss";

const BackDropModal = ({ onConfirm }) => {
    return <div className="modalBackDrop" onClick={onConfirm} ></div>

}

export default BackDropModal